t = require('views/internal/teacup-with-helpers')('card_detail')

module.exports = t.renderable (selector, icon, text, minimizedCardBack, isCustom) ->
  t.a ".button-link.card-detail-section-mini-button.#{selector}", {
    href: '#',
    title: t.l(text)
  }, ->
    t.icon icon, { class: t.classify('icon-lg': minimizedCardBack, 'icon-custom': isCustom) }
    t.span '.card-detail-section-mini-button-text', -> t.format text



// WEBPACK FOOTER //
// ./app/scripts/views/templates/card_detail_sidebar_button.coffee